export enum TEMPERATURETYPES {
  COOKOUT = 'COOKOUT',
  HOLDING = 'HOLDING',
  CORRECTIVE = 'CORRECTIVE',
  DISPOSAL = 'DISPOSAL',
  CHILLED = 'CHILLED',
}
